<div
  id="drop"
  #drop
  ngx-dropzone
  class="upload-file-control py-3"
  (change)="onFileChange($event)"
  [accept]="fileFormat"
  fxLayout="column"
  fxLayoutAlign="center center"
  [ngClass]="{ 'is-large': isLarge }"
  [ngStyle]="{ 'height.px': height }"
>
  <div fxLayout="row" fxLayoutAlign="center center">
    <i class="icon icon-cloud_upload" style="font-size: 24px; color: var(--primary-color-600)"></i>
  </div>
  <div fxLayout="row" fxLayoutAlign="center center">
    <span class="file-upload-label">{{ label }}</span>
  </div>
</div>
